export const trackEvent = (name, params = {}) => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("trackCustom", name, params);
    }
    console.log(`[analytics] ${name}`, params);
  } catch (e) {
    console.error("analytics error", e);
  }
};

export const trackVideoProgress = (() => {
  const fired = new Set();
  return (id, percent) => {
    const key = `${id}:${percent}`;
    if (fired.has(key)) return;
    fired.add(key);
    trackEvent(
      percent === 0
        ? "product_video_start"
        : percent === 100
        ? "product_video_complete"
        : `product_video_${percent}`
    );
  };
})();
